import { LuChevronLeft } from "react-icons/lu";
import "./style.css";
import { Skeleton } from "@mui/material";

export const SingleCardSkeleton = () => {
  return (
    <div className="flex_c main_container justify_content_start">
      <div className="flex_r align_items_center">
        <LuChevronLeft style={{ fontSize: "25px" }} />
        <p className="dashboard_title">Back To Home</p>
      </div>
      <div className="flex_r gap-30 single_card_details_section">
        <div className="single_card_details_img ">
          <SingleCardImageSkeleton />
        </div>
        <div className="flex_c single_card_info_details gap-20 ">
          <h1>
            <Skeleton variant="text" width={100} />
          </h1>
          <p>
            <Skeleton variant="text" width={300} />
            <Skeleton variant="text" width={300} />
          </p>
          <div className="flex_c gap-20 single_card_price">
            <p>
              <Skeleton variant="text" width={50} />
            </p>
            <div className="flex_c gap-10 ">
              <div className="flex_r gap-10 cart_stock_quantity">
                <div>
                  <Skeleton variant="rectangular" width={167} height={47} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" flex_c gap-40 single_card_details_section">
        {/* Description Section */}
        <div className="flex_c gap-20">
          <h1 className="main_header">Product Description</h1>
          <p>
            <Skeleton variant="text" width={"100%"} height={20} />
            <Skeleton variant="text" width={"100%"} height={20} />
            <Skeleton variant="text" width={"100%"} height={20} />
          </p>
        </div>
      </div>
    </div>
  );
};

export const SingleCardImageSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      width={"100%"}
      height={520}
      className="singleCard_image_skeleton"
    />
  );
};
